// extracted by mini-css-extract-plugin
module.exports = {"root":"HtmlPreview_root__WEkib","button":"HtmlPreview_button__3obkV","spinner":"HtmlPreview_spinner__18yNE","spinnerUnderlay":"HtmlPreview_spinnerUnderlay__TDgM3"};